import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/browser'

export default ({ app, router, store, Vue }) => {
  if (process.env.SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      integrations: [new Integrations.Vue({ Vue })],
      release: process.env.COMMIT,
      environment: window.location.hostname === 'app.likvi.de' ? 'production' : 'staging',
      ignoreErrors: ['ResizeObserver loop limit exceeded']
    })

    router.beforeEach((to, from, next) => {
      try {
        Sentry.addBreadcrumb({
          category: 'navigation',
          message: 'Navigated to ' + to.fullPath,
          level: Sentry.Severity.Info
        })
      } finally {
        next()
      }
    })
  }
}
